<template>
  <transition name="fade-slide-down-up">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'FadeSlideDownUp'
}
</script>

<style lang="scss">
.overflow-auto {
  &::-webkit-scrollbar {
    display: none;
  }
}
.fade-slide-down-up-enter {
  transform: translateY(100vh);
}
.fade-slide-down-up-leave-to {
  transform: translateY(100vh);
}
.fade-slide-down-up-enter-active,
.fade-slide-down-up-leave-active {
  transition: all 0.6s cubic-bezier(.645, .045, .355, 1);
}
</style>
